import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import { useApplicantFieldBindings } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantFieldBindings";
import { useApplicationFieldVisibility } from "@Client/@Composables/application-standalone/useApplicationFieldVisibility";
import { computed } from "@vue/composition-api";
import { APPLICATION_STEPS } from "@Client/@Utils/enums";
import { useFillOutVisibility } from "@Client/@Composables/application-standalone/useFillOutVisibility";
export const useIdentificationFieldVisibility = options => {
  const {
    computeSchemaVisibility
  } = useApplicationFieldVisibility();
  const {
    computeFillOutVisibility
  } = useFillOutVisibility();
  const {
    currentApplicantPath
  } = useApplicantFieldBindings({
    applicantIndex: options.applicantIndex
  });
  const currentIdentificationPath = computed(() => {
    return `${currentApplicantPath.value}[identifications][${options.identificationIndex.value}]`;
  });
  const currentIdentificationVisibilityPath = computed(() => {
    var _context;
    return _replaceAllInstanceProperty(_context = currentIdentificationPath.value).call(_context, /\[[[0-9]+\]/g, "");
  });
  const isApplicantVisibleFromFillOut = computed(() => {
    var _options$applicantId;
    return computeFillOutVisibility(APPLICATION_STEPS.IDENTIFICATIONS, {
      applicantId: (_options$applicantId = options.applicantId) == null ? void 0 : _options$applicantId.value
    }).value;
  });
  const identificationTypeVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIdentificationVisibilityPath.value + "[type]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const identificationCountryVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIdentificationVisibilityPath.value + "[country]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const identificationNumberVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIdentificationVisibilityPath.value + "[number]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const isIdentificationSectionVisibleForApplicant = computed(() => {
    return identificationTypeVisible.value || identificationCountryVisible.value || identificationNumberVisible.value;
  });
  return {
    identificationTypeVisible,
    identificationCountryVisible,
    identificationNumberVisible,
    isIdentificationSectionVisibleForApplicant
  };
};